import { FC } from 'react';
import { PrivacyPolicyPc } from './PrivacyPc/PrivacyPolicyPc';
import { usePrivacy } from '@/hooks/api/term/usePrivacy';

export const PrivacyPcPage: FC = () => {
  const { data } = usePrivacy();
  return <PrivacyPolicyPc html={data} />;
};
